module.exports = __webpack_public_path__ + "media/question2_au.d615cce9.mp3";